import { routes } from "@/routes/utils";
import { DatabaseIcon, FileText, FolderCog, LayoutDashboard, School, UserRound } from "lucide-react";

export const adminMenu = [
  {
    to: `/${routes.admin}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.admin}/${routes.masterData}`,
    title: "Master Data",
    icon: FolderCog,
  },
   {
    to: `/${routes.admin}/${routes.school}`,
    title: "School Onboarding",
    icon: School,
  },
  {
    to: `/${routes.admin}/${routes.employee}`,
    title: "Employee Management",
    icon: UserRound,
  },
  {
    to: `/${routes.admin}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
  {
    to: `/${routes.admin}/${routes.report}`,
    title: "Report",
    icon: FileText,
  },
];

export const salesOpsMenu = [
  {
    to: `/${routes.salesOps}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.salesOps}/${routes.school}`,
    title: "School Onboarding",
    icon: School,
  },
  // {
  //   to: `/${routes.salesOps}/${routes.masterData}`,
  //   title: "Master Data",
  //   icon: School,
  // },
  {
    to: `/${routes.salesOps}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];

export const financeTeamMenu = [
  {
    to: `/${routes.finance_team}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.finance_team}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.finance_team}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
  {
    to: `/${routes.finance_team}/${routes.report}`,
    title: "Report",
    icon: FileText,
  },
];

export const crmHeadMenu = [
  {
    to: `/${routes.crm_head}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.crm_head}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.crm_head}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];

export const labHeadMenu = [
  {
    to: `/${routes.lab_team_head}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.lab_team_head}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.lab_team_head}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];

export const labTeamMenu = [
  {
    to: `/${routes.lab_team}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.lab_team}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.lab_team}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];

export const inventoryTeamMenu = [
  {
    to: `/${routes.inventory_team}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.inventory_team}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.inventory_team}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];

export const regionHeadMenu = [
  {
    to: `/${routes.region_head}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.region_head}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.region_head}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];

export const relationshipManagerMenu = [
  {
    to: `/${routes.relationship_manager}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: `/${routes.relationship_manager}/${routes.school}`,
    title: "Onboarded School",
    icon: School,
  },
  {
    to: `/${routes.relationship_manager}/${routes.task}`,
    title: "Task Management",
    icon: FileText,
  },
];